<template>
  <v-app @click="showSummary">
    <Header />
    <router-view></router-view>
    <Error />
    <Ribbon v-if="isDev" />
    <Footer />
  </v-app>
</template>

<script>
window.addEventListener(
  'pageshow',
  function(evt) {
    if (evt?.persisted) {
      setTimeout(function() {
        window.location.reload()
      }, 10)
    }
  },
  false,
)

import { mapState } from 'vuex'
import axios from '@/config/api'
import Header from '@/components/bnn/Header'
import Error from '@/components/Error'
import Ribbon from '@/components/Ribbon'
import Footer from '@/components/bnn/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Error,
    Ribbon,
    Footer,
  },

  data: () => ({
    isDev: process.env.VUE_APP_ENV !== 'production',
  }),

  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
    }),
  },

  // created() {
  //   window.addEventListener('scroll', this.showSummary)
  // },

  // destroyed() {
  //   window.removeEventListener('scroll', this.showSummary)
  // },

  mounted() {
    if (event?.persisted) {
      window.location.reload()
    }

    document.addEventListener('mouseup', () => {
      this.showSummary()
    })

    // this.loadCampaign()
  },

  // watch: {
  //   $route(to) {
  //     if (this.campaign && to.name === 'Load') {
  //       this.$router.push({ name: 'Home' })
  //     }

  //     if (to.name === 'Load' || to.name === 'NoCampaign') {
  //       if (to.name === 'Load') {
  //         this.loadCampaign()
  //       }
  //     }
  //   },
  // },

  methods: {
    showSummary() {
      this.$store.dispatch('cart/showSummary', true)
      this.$forceUpdate()
    },

    async loadCampaign() {
      if (this.campaign) {
        return
      }

      const result = await axios.get('/campaigns')
      const val = result?.data?.data || null
      if (val?.id) {
        this.$store.commit('campaign/update', val)
      }
      this.$store.commit('campaign/updateLoading', false)

      if (
        this.campaign &&
        this.$route.name !== 'Home' &&
        this.$route.name !== 'Thank'
      ) {
        this.$router.push({ name: 'Home' })
      } else if (
        !this.campaign &&
        this.$route.name !== 'NoCampaign'
      ) {
        this.$router.push({ name: 'NoCampaign' })
      }
    },
  },
}
</script>

<style lang="stylus">

// font
@font-face
  font-family: 'Sukhumvit Set'
  src: url('assets/fonts/sukhumvit-set-text.woff2') format('woff2')
  font-weight: normal
  font-style: normal

@font-face
  font-family: 'SukhumvitSet'
  src: url('assets/fonts/sukhumvit-set-text.woff2') format('woff2')
  font-weight: normal
  font-style: normal


@font-face
  font-family: 'sukhumvit'
  src: url('assets/fonts/sukhumvit.eot')
  src: url('assets/fonts/sukhumvit.eot?#iefix') format('embedded-opentype')
  src: url('assets/fonts/sukhumvit.woff2') format('woff2')
  src: url('assets/fonts/sukhumvit.woff') format('woff')
  src: url('assets/fonts/sukhumvit.ttf') format('truetype')
  font-weight: normal
  font-style: normal

body
  color: #434242
  font-family: 'sukhumvit', 'Sukhumvit Set', 'Prompt', 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif !important

@media (min-width: 1264px)
  .container
    max-width: 1120px !important

@media screen and (max-width: 768px)
  .container
    max-width: 100% !important
    padding: 0 1.25rem !important

@media (min-width:769px) and (max-width: 960px)
  .container
    padding: 0 2.25rem !important

.header-margin
  height: 100px

.footer
  height: 60px
  background-color: $color-gray-400
  z-index 7
</style>
